/**
 * @fileoverview Helpers compartilhados pra renderização de documentos —
 * tanto no balão principal (MessageItem) quanto no preview de reply
 * (renderQuotedMessage em MessagesList).
 */

export const getDocumentInfo = (message) => {
  let fileName = "";
  let fileSize = "";
  let mimeType = "";

  try {
    if (message.dataJson) {
      const data = JSON.parse(message.dataJson);
      const docMsg =
        data?.message?.documentMessage ||
        data?.message?.documentWithCaptionMessage?.message?.documentMessage ||
        data?._data?.Message?.documentMessage ||
        data?._data?.Message?.documentWithCaptionMessage?.message?.documentMessage ||
        data?._data?.RawMessage?.documentWithCaptionMessage?.message?.documentMessage ||
        data?.documentMessage || {};
      fileName = docMsg.title || docMsg.fileName || "";
      mimeType = docMsg.mimetype || message.mediaType || "";
      const bytes = parseInt(docMsg.fileLength || docMsg.fileSha256?.length || 0);
      if (bytes > 0) {
        if (bytes < 1024) fileSize = bytes + " B";
        else if (bytes < 1024 * 1024) fileSize = (bytes / 1024).toFixed(0) + " KB";
        else fileSize = (bytes / (1024 * 1024)).toFixed(1) + " MB";
      }
    }
  } catch {}

  if (fileName) {
    fileName = fileName.replace(/^\d{10,}_/, "");
  }

  if (!fileName && message.mediaUrl) {
    const urlParts = message.mediaUrl.split("/");
    fileName = decodeURIComponent(urlParts[urlParts.length - 1] || "").replace(/^\d{10,}_/, "");
  }
  if (!fileName) fileName = "Documento";

  const ext = fileName.includes(".")
    ? fileName.split(".").pop().toUpperCase()
    : (mimeType.split("/").pop() || "").toUpperCase();

  return { fileName, fileSize, ext };
};

export const DOC_EXT_COLORS = {
  PDF: "#E5252A",
  DOC: "#2B579A", DOCX: "#2B579A",
  XLS: "#207245", XLSX: "#207245",
  PPT: "#D24726", PPTX: "#D24726",
  ZIP: "#F0A30A", RAR: "#F0A30A", "7Z": "#F0A30A",
  TXT: "#667781",
  CSV: "#207245",
};
